import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

/**
 * AmbassadorBadge — golden chip shown next to a user's name in profile
 * headers and (optionally) elsewhere in the app to signal official
 * Panda Ambassador status. Tier is rendered inline so at-a-glance the
 * viewer knows if this is a Gold / Silver / Bronze ambassador.
 *
 * The chip is a link to /ambassadors so curious viewers can see the
 * leaderboard and (if not an ambassador themselves) apply.
 */
const TIER_STYLE = {
  gold:   { bg: "bg-gradient-to-r from-yellow-300 to-amber-500", text: "text-black", label: "Gold" },
  silver: { bg: "bg-gradient-to-r from-zinc-300 to-zinc-400", text: "text-black", label: "Silver" },
  bronze: { bg: "bg-gradient-to-r from-amber-700 to-amber-500", text: "text-black", label: "Bronze" },
};

export default function AmbassadorBadge({ status, tier, size = "sm", linkTo = "/ambassadors" }) {
  if (status !== "approved" || !tier) return null;
  const style = TIER_STYLE[tier] || TIER_STYLE.bronze;
  const sizes = size === "sm"
    ? "text-[10px] px-2 py-0.5 gap-1"
    : "text-xs px-2.5 py-1 gap-1.5";
  const cls = `inline-flex items-center uppercase tracking-widest font-semibold rounded-full border border-black/10 shadow-sm hover:brightness-110 transition ${style.bg} ${style.text} ${sizes}`;
  const inner = (
    <>
      <Sparkles size={size === "sm" ? 10 : 12} strokeWidth={2.5} />
      {style.label} Ambassador
    </>
  );
  if (linkTo) {
    return (
      <Link
        to={linkTo}
        onClick={(e) => e.stopPropagation()}
        data-testid={`ambassador-badge-${tier}`}
        title={`Panda ${style.label} Ambassador · view leaderboard`}
        className={cls}
      >
        {inner}
      </Link>
    );
  }
  return (
    <span
      data-testid={`ambassador-badge-${tier}`}
      title={`Panda ${style.label} Ambassador`}
      className={cls}
    >
      {inner}
    </span>
  );
}
